import {instance} from '../index';

export const exchangeMembershipApplicaionsAPI = {
    getExchangeMembershipApplicaions (status, pageNumber, rowsCount) {
      return instance.get(`exchange-membership/exchange-membership-applications/${status}?page=${pageNumber}&size=${rowsCount}`);
    },
    createExchangeMembership (appId) {
      return instance.post(`exchange-membership/create/${appId}`);
    },
    createNewAccountAndExchangeMembership (appId) {
      return instance.post(`exchange-membership/create-new-account-and-exchange-membership/${appId}`);
    },
    linkAccountAndCreateExchangeMembership (data) {
      return instance.post(`exchange-membership/link-account-and-create-exchange-membership/${data.appId}/${data.accountId}`);
    },
    declineExchangeMembershipApp (appId) {
      return instance.post(`exchange-membership/decline/${appId}`);
    },
  }